import type { FC, ReactNode } from 'react'
import type { Product } from '@/types'

import { useRouter } from 'next/router'

import {
    Ellipsis,
    History,
    Pencil,
    SlidersHorizontal,
    Trash2
} from 'lucide-react'

import { Button } from '@/components/ui/button'
import { toCatalogProduct, useInventoryActions } from '@/components/inventory/inventory-actions'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

interface ProductActionsMenuProps {
    product: Product
    showDetailLink?: boolean
    size?: 'icon' | 'icon-sm'
}

const ProductActionsMenu: FC<ProductActionsMenuProps> = ({
    product,
    showDetailLink = true,
    size = 'icon-sm'
}): ReactNode => {
    const router = useRouter()
    const { openEditProduct, openMovement, openDeleteProduct } = useInventoryActions()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <Button
                        variant='ghost'
                        size={size}
                        aria-label={`Más acciones para ${product.name}`}
                    />
                }
            >
                <Ellipsis aria-hidden='true' />
            </DropdownMenuTrigger>

            <DropdownMenuContent align='end' className='w-52'>
                {showDetailLink && (
                    <DropdownMenuItem onClick={() => router.push(`/inventario/${product.id}`)} className='py-1.5'>
                        <History aria-hidden='true' />
                        Ver ficha e historial
                    </DropdownMenuItem>
                )}

                <DropdownMenuItem onClick={() => openEditProduct(product)} className='py-1.5'>
                    <Pencil aria-hidden='true' />
                    Editar producto
                </DropdownMenuItem>

                <DropdownMenuItem
                    onClick={() => openMovement({ product: toCatalogProduct(product), type: 'ajuste' })}
                    className='py-1.5'
                >
                    <SlidersHorizontal aria-hidden='true' />
                    Ajustar stock
                </DropdownMenuItem>

                <DropdownMenuSeparator />

                <DropdownMenuItem
                    variant='destructive'
                    onClick={() => openDeleteProduct({ id: product.id, name: product.name })}
                    className='py-1.5'
                >
                    <Trash2 aria-hidden='true' />
                    Eliminar
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default ProductActionsMenu
